import BackCardLayout from '../../layout/BackCardLayout/BackCardLayout';
import common from '../../util/scss/common.module.scss';
import styles from './Register3rdPartyConfirm.module.scss';
import GlobalContext from '../../contexts/GlobalContext';
import { IconFamily, IconFamily2 } from '../../icons/Icons';
import PrimaryUser from '../PrimaryUser/PrimaryUser';
import LegalAgreements from '../LegalAgreements/LegalAgreements';
import API from '../../api/api';
import Register3rdPartyContext, { ERegister3rdPartyUiState } from '../../contexts/Register3rdPartyContext';
import { FC, useContext } from 'react';
import { LoadingButton } from '@mui/lab';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';
import { Avatar, Box, Divider, Stack, Typography, useTheme } from '@mui/material';
import ScreenHeader from '../ScreenHeader/ScreenHeader';
import { getInitials } from '../../util/helpers';

const Register3rdPartyConfirm: FC = () => {
    const { language } = useContext(GlobalContext);
    const {
        register3rdPartyUiState,
        setRegister3rdPartyUiState,
        submitRegisterForm,
        firstName,
        lastName,
        canShowUsername,
    } = useContext(Register3rdPartyContext);
    const theme = useTheme();

    const handleSubmit = async () => {
        API.post.trackEvent({
            event: 'Sign In || Register Account Family First | Almost Done | Button - Create Account No Family',
        });
        setRegister3rdPartyUiState(ERegister3rdPartyUiState.loading);
        try {
            await submitRegisterForm();
        } catch {
            console.error('Failed to register account -- family first skip adding family');
            setRegister3rdPartyUiState(ERegister3rdPartyUiState.error);
        }
    };

    return (
        <PageLayoutV2>
            <Box sx={{ textAlign: { lg: 'center' } }}>
                <IconFamily2 fillColor={theme.palette.primary.main} />
            </Box>
            <ScreenHeader title={language.createAccount.createAccountCTA} />
            <Divider sx={{ mt: 1, mb: 2 }} />
            {firstName && lastName && canShowUsername && (
                <Stack direction={'row'} alignItems={'center'} data-testid="primary-user" sx={{ my: 3 }}>
                    <Avatar sizes={'60px'} sx={{ background: theme.palette.primary.main, mr: 2 }}>{`${getInitials(
                        firstName,
                        lastName,
                    )}`}</Avatar>
                    <Box>
                        <Typography component={'p'} variant={'subtitle1'}>{`${firstName} ${lastName}`}</Typography>
                    </Box>
                </Stack>
            )}
            <LoadingButton
                variant="contained"
                loading={register3rdPartyUiState === ERegister3rdPartyUiState.loading}
                disabled={register3rdPartyUiState === ERegister3rdPartyUiState.loading}
                type="button"
                onClick={handleSubmit}
                data-testid="confirm-register-account"
                size="large"
                fullWidth
            >
                {language.createAccount.createAccountCTA}
            </LoadingButton>
            <Box sx={{ my: 3 }}>
                <LegalAgreements />
            </Box>
        </PageLayoutV2>
    );
};

export default Register3rdPartyConfirm;
